import React from "react";
import YearBuildField from "./year-build-field";
import LotSizeField from "./lot-sie-field";

export default function BuildingLotMoreFilters({
  register,
  filterData,
  setValue,
  watch,
}) {
  return (
    <>
      <div className="col half_flex_form">
        <YearBuildField
          register={register}
          filterData={filterData}
          setValue={setValue}
          watch={watch}
          fieldNamePrefix="building_lot"
        />
      </div>
      <div className="col half_flex_form">
        <LotSizeField
          register={register}
          sf_label={true}
          filterData={filterData}
          fieldNamePrefix="building"
          setValue={setValue}
          watch={watch}
        />
      </div>
      <div className="col half_flex_form nested_half_flex">
        <div className="form_blk">
          <h6>Zoning</h6>
          <div className="half_flex">
            <div className="half_field">
              <input
                type="text"
                name="zonedcodelocal"
                className="input"
                placeholder="Example: C2, I3, R5"
                {...register("zonedcodelocal")}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
